import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import styled from "styled-components";

import { faPowerOff } from "@fortawesome/free-solid-svg-icons";

import { withRouter } from "react-router-dom";

const Text = styled.div`
	float: right;
	display: inline;
	margin-top: 5%;
`;

const Container = styled.div`
	width: 60%;
	cursor: pointer;
`;

const MenuFooter = ({ history }) => {
	return (
		<li className="profile">
			<div className="profile-details">
				<Container className="name_job" onClick={() => history.push("/logout")}>
					<FontAwesomeIcon icon={faPowerOff} size="2x" inverse />
					<Text className="name">Logout</Text>
				</Container>
			</div>
			<i className="bx bx-log-out" id="log_out"></i>
		</li>
	);
};

export default withRouter(MenuFooter);
